
const window = require('window');
const $ = require('rgs-jquery');

const dataTable = require('datatables.net-bs')(window, $);

$.fn.dataTable.ext.errMode = 'throw';

module.exports = dataTable;
